import { FlexColumn } from 'components/base'
import type { CurrencyMetadata } from 'indices-list'
import React, { useEffect } from 'react'
import { BoldAmount, CurrencyValue, CurrencyValueContainer, SectionTitle } from '../../styles'
import { AssetsSelect } from '../input/components/asset-selector'
import { InputContent } from './styled'
import Big from 'big.js'
import { DEFAULT_DECIMAL_DISPLAY_POSITION } from 'app-constants'
import { GLOBAL_COLORS } from 'theme'
import { marketCapNumber, valueToCurrencyFormat } from 'utils'
import { transactionAmountFormatter } from 'components/notifications/service'
import { LoaderWrapper } from '../../buy/received/styled'
import { BalanceLoader } from 'components/balance-loader'
import type { OutputAssetType } from '../../storage/interface'

interface ReceivedComponentProps {
  whiteList: CurrencyMetadata[]
  asset: CurrencyMetadata
  onAssetChange: (asset: CurrencyMetadata) => void
  output: OutputAssetType
  isDebounce: boolean
}

export const ReceivedComponent = ({
  whiteList,
  asset,
  onAssetChange,
  output,
  isDebounce,
}: ReceivedComponentProps) => {
  const [dropdownOpened, setDropdownOpened] = React.useState<boolean>(false)

  const outputAmount = output.amount ?? Big(0)
  const outputValue = output.value ?? Big(0)
  const formattedOutputAmount = !outputAmount.eq(0)
    ? transactionAmountFormatter(outputAmount.toString())
    : outputAmount.toFixed(DEFAULT_DECIMAL_DISPLAY_POSITION)

  const amount =
    outputAmount.toFixedSpecial(0).length > 8
      ? marketCapNumber(formattedOutputAmount)
      : formattedOutputAmount

  useEffect(() => {
    if (whiteList.length === 1) {
      onAssetChange(whiteList[0])
    }
  }, [whiteList, asset])
  return (
    <FlexColumn>
      <SectionTitle>You receive</SectionTitle>
      <InputContent>
        <AssetsSelect
          list={whiteList}
          onChange={setDropdownOpened}
          isOpened={dropdownOpened}
          selectedAsset={asset}
          selectAsset={onAssetChange}
        />
        <FlexColumn>
          <FlexColumn>
            <BoldAmount color={outputAmount.eq(0) ? GLOBAL_COLORS.investCurrencyGrey : undefined}>
              {isDebounce ? (
                <LoaderWrapper>
                  <BalanceLoader gray />
                </LoaderWrapper>
              ) : (
                amount
              )}
            </BoldAmount>
          </FlexColumn>
          <CurrencyValueContainer>
            <CurrencyValue>{!isDebounce && valueToCurrencyFormat(outputValue)}</CurrencyValue>
          </CurrencyValueContainer>
        </FlexColumn>
      </InputContent>
    </FlexColumn>
  )
}
